module.exports = __webpack_public_path__ + "static/media/Fargoline.128e29dd.png";